import React from 'react';
import { useSelector } from 'react-redux';
import PieChartScanValidityComponent from './pieChartScanValidity.component';

const PieChartScanValidityContainer = () => {
  const pieChartData = useSelector((state) => state.dashboard.pieChartData);
  const isLoading = useSelector((state) => state.dashboard.pieChartData.isLoading);
  const error = useSelector((state) => state.dashboard.pieChartData.error);

  return (
    <PieChartScanValidityComponent
      data={pieChartData}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default PieChartScanValidityContainer;
